import { render, staticRenderFns } from "./IconOwnFilial.vue?vue&type=template&id=95146e7c&scoped=true&"
import script from "./IconOwnFilial.vue?vue&type=script&lang=js&"
export * from "./IconOwnFilial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95146e7c",
  null
  
)

export default component.exports